import React from 'react';
import truncate from 'truncate-html';
import DOMPurify from 'dompurify';


const TruncateHTMLContent = ({ htmlContent, limit = 0, isWordLimit = false }) => {
    const sanitized = DOMPurify.sanitize(htmlContent);
    const truncated = truncate(sanitized, {
        length: limit,
        byWords: isWordLimit,
    });

    return (
        <div className='defualt-unstyled word-break' dangerouslySetInnerHTML={{ __html: truncated }} />
    );
};

export default TruncateHTMLContent;